export const siteSettings = {
  name: "Digital Exness Pro",
  link: "https://elitexoness.net",
  email: "support@elitexoness.net",
  appLink: "https://app.elitexoness.net",
};
